(ns common.util
  (:refer-clojure :exclude [format])
  #?(:clj  (:require
            [clojure.string :as string]
            ;;explicit alias for core/format use case:
            [clojure.core :as core])
     :cljs (:require
            [goog.string :as gstring]
            [goog.string.format]
            [goog.object]
            [clojure.string :as string])))

(defn other
  [[a b] attr]
  (if (= attr a) b a))

(defn empty-string
  [s]
  (or s ""))

(defn non-empty-string?
  [s]
  (and (string? s)
       (boolean (not-empty s))))

(defn kw->str
  [kw]
  (let [kw-namespace (namespace kw)
        kw-name (name kw)]
    (if (string/blank? kw-namespace)
      kw-name
      (str kw-namespace "/" kw-name))))

(defn str->keyword-if-string
  [s]
  (if-not (string? s)
    s
    (let [s (string/trim s)
          col-index (string/index-of s ":")
          kw-str (if (= 0 col-index) (subs s 1) s)]
      (keyword kw-str))))

(defn str-trim
  [s]
  (->> s
       (str)
       (string/trim)))

(defn str-trim-lcase
  [s]
  (->> s
       (str)
       (string/trim)
       (string/lower-case)))

(defn whitespace->space
  [s]
  (-> s
      (str)
      (string/replace #"\s" " ")))

(def ^:private unicode-space-chars
  "Whitespace `clojure.string/trim` does not remove. On the JVM it delegates to
   `String.trim`, which only strips code points <= U+0020, so a non-breaking
   space pasted in from Word or Excel survives every trim in this namespace.

   These are the Unicode space separators plus the line/paragraph separators.
   U+180E (Mongolian vowel separator) is deliberately absent: it was
   reclassified out of the space category in Unicode 6.3 and separates parts
   of a Mongolian word, so treating it as a space would split a real name."
  "\\s\\u00a0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000")

(def ^:private zero-width-chars
  "Invisible characters that are pure noise when they turn up in a pasted
   name: the zero-width space and the byte order mark.

   The zero-width non-joiner (U+200C) and zero-width joiner (U+200D) are
   invisible too, but they are NOT noise - they carry meaning in Persian,
   Arabic and Indic scripts, where a name with one and the same name without
   are different words. Dropping them would let two distinct people collapse
   onto one screening profile, which is a worse outcome than creating a
   duplicate, so they are preserved."
  "\\u200b\\ufeff")

(def ^:private zero-width-pattern
  (re-pattern (str "[" zero-width-chars "]")))

(def ^:private unicode-space-run-pattern
  (re-pattern (str "[" unicode-space-chars "]+")))

(def ^:private unicode-space-edges-pattern
  (re-pattern (str "^[" unicode-space-chars "]+|[" unicode-space-chars "]+$")))

(defn str-trim-unicode
  "Like `str-trim`, but also strips the Unicode whitespace that
   `clojure.string/trim` leaves in place - non-breaking space, narrow no-break
   space, byte order mark and friends. Zero-width characters are removed
   wherever they sit, not only at the ends, since they are invisible
   everywhere. nil becomes \"\", not nil."
  [s]
  (-> s
      (str)
      (string/replace zero-width-pattern "")
      (string/replace unicode-space-edges-pattern "")))

(defn match-key
  "Normalizes one value for identity matching: drops zero-width characters,
   collapses every run of whitespace (Unicode included) to a single space,
   trims, and lower-cases."
  [s]
  (-> s
      (str)
      (string/replace zero-width-pattern "")
      (string/replace unicode-space-run-pattern " ")
      (string/trim)
      (string/lower-case)))

(defn match-key-of
  "Builds a grouping key from several field values, normalizing each field
   BEFORE joining them.

   Normalizing the concatenation instead is a trap: a trailing space on a
   non-final field ends up in the middle of the key, where no trim can reach
   it, so \"Acme Oy \" + \"123\" and \"Acme Oy\" + \"123\" stay different keys.
   The separator keeps field boundaries from colliding as well."
  [parts]
  (->> parts
       (map match-key)
       (string/join "|")))

(defn match-attribute-string-ignore-case
  [entity attribute value]
  (-> entity
      (get attribute)
      (str-trim-lcase)
      (= (str-trim-lcase value))))

#?(:clj  (def format core/format)
   :cljs (def format gstring/format))

;; should work for empty values. non-empty values are
;; always shown above empty values
(defn numerical-comparator
  [dir]
  (fn [a b]
    (cond
      (and (not (number? a))
           (not (number? b)))
      0
      (not (number? a))
      1
      (not (number? b))
      -1
      (= dir :desc)
      (compare b a)
      :else (compare a b))))

(defn case-insensitive-direction-comparator
  [sort-direction]
  (let [fn-lower-case (fn [v]
                        (if v
                          (string/lower-case v)
                          ""))]
    (if (= sort-direction :desc)
      (fn [a b]
        (compare
         (fn-lower-case b)
         (fn-lower-case a)))
      (fn [a b]
        (compare
         (fn-lower-case a)
         (fn-lower-case b))))))

(defn case-insensitive-direction-func-comparator
  [f sort-direction]
  (let [fn-lower-case (fn [v]
                        (if v
                          (string/lower-case v)
                          ""))]
    (if (= sort-direction :desc)
      (fn [a b]
        (compare
         (-> b
             f
             fn-lower-case)
         (-> a
             f
             fn-lower-case)))
      (fn [a b]
        (compare
         (-> a
             f
             fn-lower-case)
         (-> b
             f
             fn-lower-case))))))

(defn direction-comparator
  [sort-direction]
  (if (= sort-direction :desc)
    (fn [a b] (compare b a))
    compare))

(defn equals?
  [v]
  (partial = v))

(defn toggle-set-item
  [items v]
  (if (contains? items v)
    (disj items v)
    (conj items v)))

(defn flip
  "Flips the argument order that is passed to a function"
  [f & xs]
  (apply f (reverse xs)))

(defn one-of?
  [one others]
  (some (partial = one) others))

(defn any-of-type?
  [types entities]
  (some
   (comp (partial contains? types)
         :entity/type)
   entities))

(defn related-items
  "Obtains flat list of items by fields that maps as one to many to each entity from entities sequence"
  [entities & fields]
  ; TODO should we need to filter out items by type?
  (->> entities
       (map (apply juxt fields))
       (flatten)
       (remove nil?)
       (map concat)
       (flatten)
       (distinct)))

(defn only-entity                                                                                   ; TODO rename and split it
  ([entity-type entities]
   (filter (comp (equals? entity-type)
                 :entity/type)
           entities))
  ([field-name field-value entities]
   (filter (comp (equals? field-value)
                 (partial flip get field-name))
           entities)))

(defn filter-by
  [fn-or-kw value coll]
  (->> coll
       (filter (fn [e]
                 (let [opt-value (fn-or-kw e)
                       res (or (= value opt-value)
                               (and (boolean? value)
                                    (= (pr-str value) opt-value)))]
                   res)))))

(defn remove-by
  [fn-or-kw value coll]
  (->> coll
       (remove (fn [e]
                 (= value (fn-or-kw e))))))

(defn remove-from-index
  [index-to-remove coll]
  (let [is-vector? (vector? coll)
        valid-index? (and (<= 0 index-to-remove)
                          (< index-to-remove (count coll)))]
    (if valid-index?
      (let [coll-vec (if is-vector? coll (vec coll))
            cleaned-vec (into
                         (subvec coll-vec 0 index-to-remove)
                         (subvec coll-vec (inc index-to-remove)))
            result (if is-vector? cleaned-vec (seq cleaned-vec))]
        result)
      coll)))

(defn find-one
  [fn-or-kw value entities]
  (->> entities
       (filter (fn [e]
                 (= value (fn-or-kw e))))
       (first)))

(defn find-first-matching-entity-str-ignore-case
  [entity-type fn-or-kw value entities]
  (let [lower-case-value (str-trim-lcase value)]
    (->> entities
         (filter (fn [e]
                   (and (= (:entity/type e) entity-type)
                        (= (str-trim-lcase (fn-or-kw e))
                           lower-case-value))))
         (first))))

(defn first-active-entity-id
  [entities]
  (->> entities
       (remove :common/disabled?)
       (first)
       :db/id))

(defn select-values
  [ks m]
  (->> ks
       (reduce (fn [vs k]
                 (->> k
                      (get m)
                      (conj vs)))
               [])
       (filter some?)))

(defn remove-nil-vals
  [m]
  (into {} (remove (comp nil? second) m)))

(defn empty-value?
  [value]
  (cond (number? value)
        false
        (string? value)
        (empty? value)
        (coll? value)
        (empty? value)
        :else
        (nil? value)))

(defn remove-empty-vals
  [m]
  (->> m
       (remove (fn [[_ val]]
                 (empty-value? val)))
       (into {})))

(defn blank-value?
  [val]
  (or (nil? val)
      (and (string? val)
           (string/blank? val))
      (and (coll? val)
           (empty? val))))

(defn remove-blank-vals
  [m]
  (->> m
       (remove (fn [[_ val]]
                 (blank-value? val)))
       (into {})))

(defn ->proper-url
  "checks and corrects urls"
  ([s] (->proper-url s :https))
  ([s preferred-protocol]
   (when s
     (let [maybe-url-pattern
           #"^(([a-zA-Z]+://)|([a-zA-Z]+:/)|([a-zA-Z]+:)|(\\)|(https$|http$|htt$|ht$|h$))"
           after-protocol (string/replace s maybe-url-pattern "")]
       (if (and (not (re-find maybe-url-pattern s))
                (> (count after-protocol) 3))
         (str (if (= preferred-protocol :http) "http://" "https://")
              after-protocol)
         s)))))

;; https://crossclj.info/ns/medley/1.0.0/medley.core.html#_distinct-by
(defn distinct-by
  "Returns a lazy sequence of the elements of coll, removing any elements that
  return duplicate values when passed to a function f."
  ([f]
   (fn [rf]
     (let [seen (volatile! #{})]
       (fn
         ([] (rf))
         ([result] (rf result))
         ([result x]
          (let [fx (f x)]
            (if (contains? @seen fx)
              result
              (do (vswap! seen conj fx)
                  (rf result x)))))))))
  ([f coll]
   (let [step (fn step [xs seen]
                (lazy-seq
                 ((fn [[x :as xs] seen]
                    (when-let [s (seq xs)]
                      (let [fx (f x)]
                        (if (contains? seen fx)
                          (recur (rest s) seen)
                          (cons x (step (rest s) (conj seen fx)))))))
                  xs
                  seen)))]
     (step coll #{}))))

;;reporting periods for target-year & -period
(defn yperiods
  [granularity forecast-requested? target-year target-period]
  (let [max-period (if (= granularity :monthly)
                     12
                     4)
        periods-before (cond (= granularity :monthly) 11
                             (= granularity :quarterly) 3
                             :else -1)
        periods-after (if forecast-requested?
                        periods-before
                        0)
        periods (range (- target-period periods-before) (+ target-period (inc periods-after)))
        yperiods (->> periods
                      (map (fn [period]
                             (cond (< period 1) [(dec target-year) (+ period max-period)]
                                   (> period max-period) [(inc target-year) (- period max-period)]
                                   :else [target-year period]))))]
    yperiods))

(defn tab-separated-string
  [data-array]
  (string/join "\r\n"
               (map (partial string/join "\t") data-array)))

(defn join-with-and
  "Join a list of strings with \"and\" at the end.

  Example:
  [\"item-1\"] -> \"item-1\"
   [\"item-1\" \"item-2\"] -> \"item-1 and item-2\"
   [\"item-1\" \"item-2\" \"item-3\"] -> \"item-1, item-2 and item-3\""
  [items]
  (if (empty? items)
    ""
    (if (= 1 (count items))
      (first items)
      (str (string/join ", " (butlast items))
           " and "
           (last items)))))

(defn index-of
  "return the index of the supplied item, or nil"
  ([v item]
   (index-of v item nil))
  ([v item default]
   (let [len (count v)]
     (loop [i 0]
       (cond
         (<= len i) default
         (= item (get v i)) i
         :else (recur (inc i)))))))

(defn owner-attribute?
  [attr]
  (some #{attr}
        [:oppo/owner
         :company/company-owner
         :person/contact-owner
         :holding/owner
         :fundraising-opportunity/owner]))

(defn separator-kw?
  [kw]
  (and (keyword? kw)
       (= "separator" (namespace kw))))

(defn new-deal-tag?
  [attribute]
  (->> attribute
       str
       (take 10)
       (= (seq ":oppo/tag-"))))

(defn parse-domain
  [candidate]
  (when (string? candidate)
    (as-> candidate candidate
      (if (string/includes? candidate "://")
        (subs candidate (+ (string/index-of candidate "://") 3))
        candidate)
      (if (string/includes? candidate "/")
        (subs candidate 0 (string/index-of candidate "/"))
        candidate)
      (if (string/includes? candidate "?")
        (subs candidate 0 (string/index-of candidate "?"))
        candidate))))

;; sort direction
(defn dir-label
  [field-schema dir]
  (let [data-type (:field/data-type field-schema)
        [asc desc] (cond
                     (some #{data-type}
                           [:data.type/number :data.type/datetime :data.type/integer
                            :data.type/currency-value :data.type/long :data.type/date])
                     ["0->9" "9->0"]
                     :else
                     ["A->Z" "Z->A"])]
    (if (= dir "DESC")
      desc
      asc)))

(defn indices
  [pred coll]
  (keep-indexed #(when (pred %2) %1) coll))

(defn cs
  [& classes]
  (string/join " "
               (->> classes
                    (filter identity)
                    (map name))))

(defn currency-symbol?
  [attribute]
  (and (keyword? attribute)
       (-> attribute
           name
           (string/ends-with? "--sym"))))

;;get the currency attribute based on the given currency symbol attribute:
(defn currency-symbol->currency
  [attribute]
  (let [ns (namespace attribute)
        n (name attribute)
        new-n (string/replace n #"--sym$" "")]
    (keyword ns new-n)))

(defn currency->symbol
  [attribute]
  (let [ns (namespace attribute)
        n (name attribute)]
    (keyword ns (str n "--sym"))))

(defn truncate
  "truncates string to a certain limit"
  [character-limit string-value]
  (when string-value
    (subs string-value 0 (min character-limit (count string-value)))))

(defn get-key
  [options value]
  (let [lc (str-trim-lcase value)]
    (some #(when (= (-> %
                        :label
                        str-trim-lcase)
                    lc)
             (:key %))
          options)))

(defn get-label
  [options key]
  (some #(when (= key (:key %)) (:label %)) options))

(defn swap-indices
  [v i1 i2]
  (assoc v i2 (v i1) i1 (v i2)))

(defn year-strings
  [start-year end-year]
  (let [years (range end-year start-year -1)
        string-years (->> years
                          (map str)
                          (doall)
                          (vec))]
    string-years))

(defn one-element?
  "Checks if a sequence has exactly one element."
  [xs]
  (boolean
   (and (coll? xs)
        (seq xs)
        (empty? (rest xs)))))

(defn multiple?
  "Checks if a sequence has more than one elements."
  [xs]
  (boolean
   (and (coll? xs)
        (seq xs)
        (seq (rest xs)))))

(defn default-boolean
  [default-value val?]
  (boolean (if (nil? val?)
             default-value
             val?)))

;; Example for an entity-id indexed db:
#_(->> @session/entities
       (filter-kv (fn [[_entity-id entity]]
                    (= (:entity/type entity) :entity.type/oppo))))
(defn filter-kv
  "Filters elements in a hashmap based on a predicate (fn [[k v]] ...)"
  [pred coll]
  (->> coll
       (reduce-kv (fn [result k v]
                    (if (pred [k v])
                      (assoc result k v)
                      result))
                  {})))

(defn remove-kv
  [pred coll]
  (filter-kv (complement pred) coll))

(defn reorder-list
  [items source-index destination-index]
  (let [items (vec items)
        item-to-move (get items source-index)]
    (if (and item-to-move
             (not= source-index destination-index))
      (let [items-after-removal (vec (concat (subvec items 0 source-index)
                                             (subvec items (inc source-index))))]
        (vec (concat (take destination-index items-after-removal)
                     [item-to-move]
                     (drop destination-index items-after-removal))))
      items)))

(defn non-number?
  [n]
  #?(:clj  (not (number? n))
     :cljs (or (not (number? n))
               (js/isNaN n))))

(defn sum-ignore-non-numbers
  [coll]
  (->> coll
       (remove non-number?)
       (apply +)))

(defn none?
  [coll]
  (not-any? identity coll))

(defn map-kv
  "Maps a function over [k v] elements in a hashmap. The mapping function's
   return value key-value pair [result-k result-v] is assoc'd into the resulting
   hashmap (unless nil)."
  [func coll]
  (->> coll
       (reduce-kv (fn [result k v]
                    (let [[new-k new-v :as mapped] (func [k v])]
                      (if (nil? mapped)
                        result
                        (assoc result new-k new-v))))
                  {})))

(defn fncall-or-value
  "If fn-or-value is a function, call it with args, otherwise return it as is"
  [fn-or-value & args]
  (if (fn? fn-or-value)
    (apply fn-or-value args)
    fn-or-value))

(defn vector-move
  "Returns a vector where the element from prev-index has been moved to new-index"
  [v prev-index new-index]
  {:pre [(vector? v)]}
  (let [items (into (subvec v 0 prev-index) (subvec v (inc prev-index)))]
    (-> (subvec items 0 new-index)
        (conj (get v prev-index))
        (into (subvec items new-index)))))

(defn vec-remove
  "remove elem in coll"
  [pos coll]
  (vec (into (subvec coll 0 pos) (subvec coll (inc pos)))))

(defn vec-insert
  [index elem coll]
  (vec (concat (subvec coll 0 index)
               [elem]
               (subvec coll index))))

(defn update-at
  "Update an item in a collection.
   update-fn gets called with the item and args."
  [coll update-index update-fn & args]
  (->> coll
       (map-indexed (fn [index item]
                      (if (= index update-index)
                        (apply update-fn item args)
                        item)))
       (vec)))

(defn vec-move
  [v from to]
  (if (> from to)
    (vec (concat (subvec v 0 to)
                 [(get v from)]
                 (subvec v to from)
                 (subvec v (inc from) (count v))))
    (vec (concat (subvec v 0 from)
                 (subvec v (inc from) (inc to))
                 [(get v from)]
                 (subvec v (inc to) (count v))))))

(defn reverse-attribute
  [attribute]
  (keyword (namespace attribute) (str "_" (name attribute))))

(defn forward-attribute
  "Inverse of reverse-attribute: :investor/_legal-entity -> :investor/legal-entity.
   nil if `attribute`'s name doesn't carry the Datomic reverse-ref `_` prefix."
  [attribute]
  (let [n (name attribute)]
    (when (string/starts-with? n "_")
      (keyword (namespace attribute) (subs n 1)))))

(defn transpose
  [matrix]
  (apply mapv vector matrix))

(defn keys-in
  "Returns a sequence of all key paths in a given map."
  [m]
  (if (map? m)
    (vec
     (mapcat (fn [[k v]]
               (let [sub (keys-in v)
                     nested (map #(into [k] %) (filter (comp not empty?) sub))]
                 (if (seq nested)
                   nested
                   [[k]])))
             m))
    []))

(defn clamp
  [min-val max-val val]
  (when val
    (max (min max-val val) min-val)))

(defn all-uppercase?
  [s]
  (= s
     (string/upper-case s)))

;; more complex lower-casing: lower-case unless
;; the full word is upper-case, such as "CEO" => "CEO"
;; or "Contact LP" => "contact LP"
(defn smart-lower-case
  [s]
  ;;split by word boundaries:
  (let [by-word (re-seq #"\w+|\W+" (str s))
        lc (->> by-word
                (mapv (fn [word]
                        (if (and (all-uppercase? word)
                                 ;; possible "A [something]"
                                 (not (= "A" word)))
                          word
                          (string/lower-case word))))
                (apply str))
        ;; previous "A" corner case fails for "M&A":
        result (string/replace lc "M&a" "M&A")]
    result))

(defn concatv
  "Vector version of `concat`. Note: in empty case returns `[]` as opposed to `nil`"
  [& colls]
  (into
   []
   (mapcat identity)
   colls))

;; faster than (->> coll (filter x) first),
;; stops immediately when matching element is found:
(defn find-first-by
  ([f val coll]
   (->> coll
        (reduce (fn [_ el]
                  (when (= (f el) val)
                    (reduced el)))
                nil)))
  ;; transducer version
  ([f val xform coll]
   (let [rf (fn
              ([el] el)
              ([_ el] (when (= (f el) val)
                        (reduced el))))]
     (transduce xform rf nil coll))))

(defn find-first
  ([pred coll]
   (->> coll
        (reduce (fn [_ el]
                  (when (pred el)
                    (reduced el)))
                nil)))
  ;; transducer version
  ([pred xform coll]
   (let [rf (fn
              ([el] el)
              ([_ el] (when (pred el)
                        (reduced el))))]
     (transduce xform rf nil coll))))

(defn contains-path?
  [m path]
  (contains? (get-in m (butlast path)) (last path)))
